import { Box, styled, Typography } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
  flex: 1,
}));

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
}));


const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.5rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));


const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(0.75),
  marginBottom: theme.spacing(0.5),
}));

const Field = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '30%',
});

const Label = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '0.875rem',
});

const LabelRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

const Value = styled(Typography)({
  fontSize: '0.875rem',
});

const MutedValue = styled(Value)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

const StatusBadge = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(212, 244, 221, 0.12)' : '#d4f4dd',
  color: theme.palette.mode === 'dark' ? '#86efac' : '#3b8c4a',
  fontWeight: 600,
  fontSize: '0.7rem',
  borderRadius: 6,
  padding: '2px 8px',
  display: 'inline-block',
  marginTop: 2,
  width: 'fit-content',
}));

const UserSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.25rem',
});

const FinancialFieldsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
}));

const PersonnelRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

const FinancialField = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: theme.spacing(0.75),
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.action.hover,
  minHeight: 88,
  boxSizing: 'border-box',
}));

const FinancialFieldHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
});

const FinancialDateBadge = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  padding: theme.spacing(0.25, 1),
  borderRadius: theme.spacing(0.75),
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: 1.4,
  whiteSpace: 'nowrap',
}));

const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

export {
  Container,
  Row,
  HeaderRow,
  Field,
  Label,
  Value,
  MutedValue,
  StatusBadge,
  UserSection,
  StyledLinkSpan,
  LabelRow,
  FinancialFieldsGrid,
  FinancialField,
  FinancialFieldHeader,
  FinancialDateBadge,
  PersonnelRow,
  ToggleContainer,
};
